import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Navbar from './common/components/Navbar/Navbar';
import { useAuth } from './customHooks/useAuth';
import Routes from './routes/routes';
import theme from './theme';

import './assets/styles/layout.css';
import Overlay from './common/components/Overlay';
import DiagramBpmnIndex from './modules/BpmnIoDiagram/Index';
import { closeDiagram } from './slices/diagramViewerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store';
import { DiagramViewerState } from './slices/diagramViewerInterface';

const AppLayout: React.FC = () => {
  const location = useLocation();
  const isAuthenticated = useAuth();
  const isXPLR = location.pathname.includes('/design-nexus');

  const showNavbarOnRoutes = [
    '/industry',
    '/process',
    '/process-xplr',
    '/solution-xplr',
    '/ideation-xplr',
    '/portfolio',
    '/design-nexus',
    '/diagram',
    '/',
    '/enterprise-context',
    '/approval-requests',
    '/ideation-coi/:id',
    '/ideation-chatbot/:id',
    '/opportunity/:id',
    '/data-xplr',
    '/data-xplr/:id',
  ];

  const shouldShowNavbar =
    isAuthenticated &&
    showNavbarOnRoutes.some((route) => {
      if (route.includes(':')) {
        // convert pattern like '/ideation-coi/:id' to a regex
        const regex = new RegExp('^' + route.replace(':id', '[^/]+') + '$');
        return regex.test(location.pathname);
      }
      return location.pathname === route;
    });

  const dispatch = useDispatch();
  const { isOpen = false } = useSelector<RootState, DiagramViewerState>(
    (state) => state.diagramViewer
  );

  useEffect(() => {
    if (isOpen) {
      dispatch(closeDiagram());
    }
  }, [location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: `calc(100% - ${shouldShowNavbar ? '60px' : '0px'})`,
          marginTop: `${shouldShowNavbar ? '60px' : '0px'}`,
          overflow: 'hidden',
        }}
      >
        {shouldShowNavbar && <Navbar />}

        <Box
          component="main"
          className={isXPLR ? 'no-scroll' : ''}
          sx={{
            flex: 1,
            overflowY: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {/* Toaster and Providers are now mounted once in main.tsx */}
          <Routes />
        </Box>
        <Overlay open={isOpen} onClose={() => dispatch(closeDiagram())} showCloseButton={false}>
          <DiagramBpmnIndex />
        </Overlay>
      </Box>
    </ThemeProvider>
  );
};

export default AppLayout;
